import { AccumulatorTrade } from '@/models/trade';

export const computeWay = (trade: AccumulatorTrade) => {
  return trade.instrumentName === 'FxoTargetAccumulator' ? trade.currencyPairSide : trade.side;
};
